import { Alert } from "reactstrap"
import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

// Shown when a resource could not be loaded. Partner Center answers in
// English and in its own vocabulary ("Caller should have a valid entra role"),
// which is not something to put in front of a customer, so a known reason is
// rendered as our own localised wording. Admins additionally get the raw
// upstream text, because they are the ones who have to act on it.
const ResourceError = ({ resource }) => {
  const { t } = useTranslation()
  const isAdmin = useSelector((state) => state.user.isAdmin)

  if (!resource || !resource.error) return null

  const known = resource.errorCode === "delegatedAdminRequired"

  return (
    <Alert color="warning" className="mb-0">
      {known
        ? t("_noDelegatedAdmin")
        : `${t("_dataUnavailable")}: ${resource.error}`}
      {known && isAdmin && (
        <small className="d-block mt-2 text-muted">{resource.error}</small>
      )}
    </Alert>
  )
}

export default ResourceError
